import "./App.css";
import Home from "./Pages/Home";

function App() {
  return (
    <div className="w-full h-screen">
      <Home />
    </div>
  );
}

export default App;
